"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ToggleButtonProps_1 = require("./ToggleButtonProps");
var styles = require("./ToggleButton.css");
var __1 = require("../..");
var ButtonProps_1 = require("../../atoms/Button/ButtonProps");
var ToggelButtonMaps_1 = require("./ToggelButtonMaps");
var ToggleButton = /** @class */ (function (_super) {
    __extends(ToggleButton, _super);
    function ToggleButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            firstButtonActive: _this.props.data.defaultChecked === '0' ? true : false,
            secondButtonActive: _this.props.data.defaultChecked !== '0' ? true : false,
        };
        _this.firstButtonClick = _this.firstButtonClick.bind(_this);
        _this.secondButtonClick = _this.secondButtonClick.bind(_this);
        return _this;
    }
    ToggleButton.prototype.componentWillMount = function () {
        this.props.data.defaultChecked === '0' ? this.setState({ firstButtonActive: true }) :
            this.setState({ secondButtonActive: true });
    };
    ToggleButton.prototype.firstButtonClick = function () {
        if (!this.state.firstButtonActive) {
            this.setState({ firstButtonActive: true });
            this.setState({ secondButtonActive: false });
            if (this.props.events && this.props.events.onClick) {
                this.props.events.onClick(this.props.data.text1);
            }
        }
    };
    ToggleButton.prototype.secondButtonClick = function () {
        if (!this.state.secondButtonActive) {
            this.setState({ firstButtonActive: false });
            this.setState({ secondButtonActive: true });
            if (this.props.events && this.props.events.onClick) {
                this.props.events.onClick(this.props.data.text2);
            }
        }
    };
    ToggleButton.prototype.render = function () {
        var button1Color = this.props.data.color1 ? this.props.data.color1 : ButtonProps_1.ButtonColor.BLUE;
        var button2Color = this.props.data.color2 ? this.props.data.color2 : ButtonProps_1.ButtonColor.WHITE;
        var button1Type = this.props.data.type1 ? this.props.data.type1 : ButtonProps_1.ButtonType.PRIMARY;
        var button2Type = this.props.data.type2 ? this.props.data.type2 :
            this.props.options.backgroundcolor === ToggleButtonProps_1.BackGroundColor.BLACK ? ButtonProps_1.ButtonType.GHOST : ButtonProps_1.ButtonType.PRIMARY;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: [styles.radioGroupContainer, ToggelButtonMaps_1.BackgroundColorMap.get(this.props.options.backgroundcolor)].join(' '), role: "radiogroup" },
            React.createElement(__1.Button, { data: { text: this.props.data.text1 }, events: { onClick: this.firstButtonClick }, options: { accessibility: this.props.options ? this.props.options.accessibility1 : '',
                    className: (this.state.firstButtonActive ? 'active' : 'inactive'),
                    color: (this.state.firstButtonActive ? button1Color : button2Color),
                    type: (this.state.firstButtonActive ? button1Type : button2Type),
                } }),
            React.createElement(__1.Button, { data: { text: this.props.data.text2 }, events: { onClick: this.secondButtonClick }, options: { accessibility: this.props.options ? this.props.options.accessibility2 : '',
                    className: (this.state.secondButtonActive ? 'active' : 'inactive'),
                    color: (this.state.secondButtonActive ? button1Color : button2Color),
                    type: (this.state.secondButtonActive ? button1Type : button2Type),
                } })));
    };
    ToggleButton.defaultProps = {
        options: {
            backgroundcolor: ToggleButtonProps_1.BackGroundColor.BLACK,
        },
    };
    return ToggleButton;
}(React.Component));
exports.default = ToggleButton;
//# sourceMappingURL=ToggleButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/ToggleButton/ToggleButton.js
// module id = 1375
// module chunks = 8